import { c as _c } from "react/compiler-runtime";
import { DangerButton, Modal, PrimaryButton, toast } from '@systemeio/ui';
import { ContactSubscriptionsInterface } from 'modules/contacts/contact-page/types/contact-subscriptions-interface';
import { SubscriptionInterface } from 'modules/payment/subscriptions/types/subscription-interface';
import React, { useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUnsubscribe } from '../hooks/use-unsubscribe';
import { getPaymentProcessorUnsubscribeOptions } from '../utils/get-payment-processor-unsubscribe-options';
interface UnsubscribeModalProps<Instance extends SubscriptionInterface | ContactSubscriptionsInterface> {
  opened: boolean;
  onClose: () => void;
  subscription: Instance;
  onUnsubscribe: (subscription: Instance) => Promise<void>;
}
function UnsubscribeModal(t0) {
  const $ = _c(65);
  const {
    opened,
    onClose,
    subscription,
    onUnsubscribe
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [error, setError] = useState("");
  let t1;
  if ($[0] !== subscription.id || $[1] !== subscription.paymentProcessor || $[2] !== subscription.subscriptionItems) {
    t1 = getPaymentProcessorUnsubscribeOptions(subscription.paymentProcessor, subscription.id, subscription.subscriptionItems);
    $[0] = subscription.id;
    $[1] = subscription.paymentProcessor;
    $[2] = subscription.subscriptionItems;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    requestMethod,
    getRequestUrl,
    getRequestBody
  } = t1;
  let t2;
  if ($[4] !== getRequestBody || $[5] !== getRequestUrl || $[6] !== requestMethod) {
    t2 = {
      requestMethod,
      getRequestUrl,
      getRequestBody
    };
    $[4] = getRequestBody;
    $[5] = getRequestUrl;
    $[6] = requestMethod;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    unsubscribe,
    isFetchingWhenEnds,
    isFetchingNow
  } = useUnsubscribe(t2);
  let t3;
  if ($[8] !== onClose || $[9] !== onUnsubscribe || $[10] !== subscription || $[11] !== t || $[12] !== unsubscribe) {
    t3 = async () => {
      ;
      try {
        await unsubscribe({
          time: "when_ends"
        });
        await onUnsubscribe(subscription);
        onClose();
        toast.success(t("dashboard.subscriptions.unsubscribed_later"));
      } catch (t4) {
        toast.error(t("global.error"));
      }
    };
    $[8] = onClose;
    $[9] = onUnsubscribe;
    $[10] = subscription;
    $[11] = t;
    $[12] = unsubscribe;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const unsubWhenEnds = t3;
  let t4;
  if ($[14] !== onClose || $[15] !== onUnsubscribe || $[16] !== subscription || $[17] !== t || $[18] !== unsubscribe) {
    t4 = async () => {
      ;
      try {
        await unsubscribe({
          time: "now"
        });
        await onUnsubscribe(subscription);
        onClose();
        toast.success(t("dashboard.subscriptions.unsubscribed"));
      } catch (t5) {
        toast.error(t("global.error"));
      }
    };
    $[14] = onClose;
    $[15] = onUnsubscribe;
    $[16] = subscription;
    $[17] = t;
    $[18] = unsubscribe;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const unsubNow = t4;
  let t5;
  if ($[20] !== onClose) {
    t5 = () => {
      onClose();
    };
    $[20] = onClose;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setError("");
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t) {
    t7 = t("dashboard.subscriptions.unsubscribe_confirm");
    $[23] = t;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const t8 = isFetchingWhenEnds || isFetchingNow;
  const t9 = subscription.subscriptionItems?.[0]?.orderItem?.pricePlan?.innerName;
  const t10 = subscription.customer?.fullName;
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = {
      product: t9,
      customer: t10
    };
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      b: <span className="font-bold" />
    };
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t || $[30] !== t11) {
    t13 = <div className="flex justify-center"><p><span className="text-text-primary text-base"><TransLoco t={t} i18nKey="dashboard.subscriptions.unsubscribe_confirm_text" values={t11} components={t12} /></span></p></div>;
    $[29] = t;
    $[30] = t11;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== unsubNow) {
    t14 = async e_1 => {
      e_1.preventDefault();
      await unsubNow();
    };
    $[32] = unsubNow;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t("dashboard.subscriptions.unsub_now");
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== isFetchingNow || $[37] !== isFetchingWhenEnds || $[38] !== t14 || $[39] !== t15) {
    t16 = <DangerButton isFetching={isFetchingNow} width="large" onClick={t14} disabled={isFetchingWhenEnds}>{t15}</DangerButton>;
    $[36] = isFetchingNow;
    $[37] = isFetchingWhenEnds;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== unsubWhenEnds) {
    t17 = async e_2 => {
      e_2.preventDefault();
      await unsubWhenEnds();
    };
    $[41] = unsubWhenEnds;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t) {
    t18 = t("dashboard.subscriptions.unsub_period");
    $[43] = t;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== isFetchingNow || $[46] !== isFetchingWhenEnds || $[47] !== t17 || $[48] !== t18) {
    t19 = <PrimaryButton isFetching={isFetchingWhenEnds} className="w-full text-base" width="large" onClick={t17} disabled={isFetchingNow} type="submit">{t18}</PrimaryButton>;
    $[45] = isFetchingNow;
    $[46] = isFetchingWhenEnds;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t16 || $[51] !== t19) {
    t20 = <div className="max-sm:flex-wrap flex justify-center gap-4">{t16}{t19}</div>;
    $[50] = t16;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== error) {
    t21 = <FieldErrorAndDescription error={error} errorClassName="text-center" />;
    $[53] = error;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t13 || $[56] !== t20 || $[57] !== t21) {
    t22 = <form className="flex flex-col gap-6 lg:gap-10">{t13}{t20}{t21}</form>;
    $[55] = t13;
    $[56] = t20;
    $[57] = t21;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  let t23;
  if ($[59] !== opened || $[60] !== t22 || $[61] !== t5 || $[62] !== t7 || $[63] !== t8) {
    t23 = <Modal opened={opened} onClose={t5} className="max-w-max" afterLeave={t6} title={t7} isFetching={t8} isCentered={true}>{t22}</Modal>;
    $[59] = opened;
    $[60] = t22;
    $[61] = t5;
    $[62] = t7;
    $[63] = t8;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  return t23;
}
export default UnsubscribeModal;